




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'badge-ecofriendly-component',
})
export default class EcoFriendlyComponent extends Vue {
}
